import React, { useState } from "react";
import BakeryLayout from "./BakeryLayout.tsx"; // Import BakeryLayout
import heroImage from "./images/hero-tech.jpg";  // Assuming you still want the hero image for business

const BusinessLayout: React.FC = () => {
  const [isBakery, setIsBakery] = useState(false); // State to toggle between business and bakery layout

  const services = [
    {
      title: "Webdesign",
      shortDesc: "Stunning, responsive designs",
      moreInfo:
        "We create custom, modern, and user-friendly designs that captivate your audience and elevate your brand."
    },
    {
      title: "Web Development",
      shortDesc: "Robust and scalable solutions",
      moreInfo:
        "Our team builds secure and high-performance web applications tailored to your business needs using the latest technologies."
    },
    {
      title: "Consulting",
      shortDesc: "Expert guidance for your business",
      moreInfo:
        "We provide strategic IT consulting to optimize your digital transformation and drive business growth."
    },
    {
      title: "Maintenance",
      shortDesc: "Reliable support and updates",
      moreInfo:
        "Our maintenance services ensure your website stays secure, updated, and performing at its best around the clock."
    },
    {
      title: "Process Automation", // New Service Added
      shortDesc: "Streamline and optimize workflows",
      moreInfo:
        "We leverage advanced automation tools to reduce repetitive tasks, enhance operational efficiency, and improve productivity using technologies like RPA and AI."
    }
  ];

  return (
    <>
      {isBakery ? (
        <BakeryLayout />
      ) : (
        <div>
          {/* Business Layout */}
          <section
            id="hero"
            className="h-screen flex items-center justify-center bg-cover bg-center relative z-10"
            style={{ backgroundImage: `url(${heroImage})` }}
          >
            <div className="absolute inset-0 bg-black opacity-30"></div>
            <div className="relative z-30 text-center text-white px-6">
              <h1 className="text-5xl sm:text-6xl lg:text-7xl font-extrabold leading-tight mb-6">
                Transforming Ideas into Digital Success
              </h1>
              <p className="text-lg sm:text-xl md:text-2xl mb-8">
                We specialize in creating innovative, high-performance web solutions tailored to your business needs.
              </p>
              <button
                onClick={() => setIsBakery(!isBakery)}
                className="bg-slate-900 hover:bg-blue-200 text-white px-8 py-3 rounded-lg text-lg transition-all duration-300"
              >
                Explore
              </button>
            </div>
          </section>

          <section id="product" className="py-16 px-6">
            <div className="max-w-7xl mx-auto text-center">
              <div className="relative inline-block text-center">
                <h2 className="text-4xl font-bold text-gray-800 ">What we offer</h2>
                <img 
                  src="/images/unterstrch.png"  
                  alt="Underline" 
                  className="absolute left-1/2 transform -translate-x-3/4 -bottom-4 w-3/4 opacity-80 z-20"
                />
              </div>
              <div className="grid pt-10 md:grid-cols-2 lg:grid-cols-2 gap-8">
                {services.map((service, index) => (
                  <div
                    key={index}
                    className="bg-white p-6 shadow-lg rounded-lg group relative overflow-hidden transition-transform duration-300 transform hover:scale-105 hover:shadow-xl hover:bg-blue-200 cursor-pointer"
                  >
                    <h3 className="text-xl font-semibold text-gray-700 relative">
                      {service.title}
                      <img
                        src="/images/unterstrch.png"
                        alt="Underline"
                        className="relative left-1/3 transform -translate-x-1 bottom-4 w-1/5 opacity-80 z-10 transition-opacity duration-300 group-hover:opacity-0"
                      />
                    </h3>
                    <p className="text-gray-500">{service.shortDesc}</p>
                    <div className="absolute inset-0 bg-white bg-opacity-95 flex flex-col items-center justify-center text-center p-4 opacity-0 transition-opacity duration-300 group-hover:opacity-100 hover:bg-blue-200">
                      <p className="text-gray-700 bg-blue-200">{service.moreInfo}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
        </div>
      )}
    </>
  );
};

export default BusinessLayout;
